<select [(ngModel)]="languageService.selectedLocale">
  <option *ngFor="let l of languageService.locales" [ngValue]="l">{{l.displayName}}</option>
</select>
